<template>
  <div>
    <andes-header></andes-header>
    <breadcrumb v-if="!ancillaryFromItinerary" activePage="2"></breadcrumb>
    <div class="container">
      <div class="row" v-if="ancillaryFromItinerary">
        <div class="col-12 mb-3">
          <h3 class="m-0">Editar extras</h3>
          <p class="text-muted mb-0">Reserva {{booking.RecordLocator}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-9">
          <extras-catalog></extras-catalog>
          <extras-message></extras-message>
        </div>
        <div class="col-sm-3">
          <summary-form v-if="!ancillaryFromItinerary" :onContinue="onContinue"></summary-form>
          <div v-else class="ancillary-summary sticky-top pt-2">
            <div class="ancillary-summary-card">
              <h4>{{ $t('Tu reserva') }}</h4>
              <div class="ancillary-summary-row">
                <span>{{ $t('Total') }}</span>
                <strong>ARS {{toCurrencyFormat(booking.TotalCost)}}</strong>
              </div>
              <div class="ancillary-summary-row" v-if="balanceDue > 0">
                <span>Saldo a pagar</span>
                <strong class="ancillary-summary-due">ARS {{toCurrencyFormat(balanceDue)}}</strong>
              </div>
              <button class="btn btn-andes btn-block mt-3" type="button" @click="onContinue">{{ $t('Continuar') }}</button>
              <button type="button" class="btn btn-link btn-block ancillary-summary-back" @click="backToItinerary">
                {{ $t('Volver al itinerario') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <andes-footer></andes-footer>
    <loading-modal v-if="loading"></loading-modal>
  </div>
</template>
<script>
  import AndesHeader from "../components/AndesHeader";
  import Breadcrumb from "../components/Breadcrumb";
  import SummaryForm from "../components/SummaryForm";
  import LoadingModal from "../components/LoadingModal";
  import AndesFooter from "../components/AndesFooter";
  import ExtrasMessage from "../components/extras/ExtrasMessage";
  import ExtrasCatalog from "../components/extras/ExtrasCatalog";
  import { mapState } from 'vuex';
  import { bookingHasCharterFlight, formatMoney } from "../utils/utils";
  export default {
    name: "ExtrasPage",
    components: {ExtrasCatalog, ExtrasMessage, AndesFooter, LoadingModal, SummaryForm, Breadcrumb, AndesHeader},
    computed: {
      ...mapState(['booking', 'loading', 'ancillaryFromItinerary']),
      balanceDue: function () {
        return parseFloat(this.booking.BalanceDue || 0);
      },
    },
    methods: {
      toCurrencyFormat: function (amount) {
        return formatMoney(amount);
      },
      backToItinerary: function () {
        this.$store.commit('ancillaryFromItinerary', false);
        this.$router.replace('itinerary');
      },
      goAfterAncillary: function () {
        if (this.balanceDue > 0) {
          this.$store.commit('afterPaymentRoute', 'itinerary');
          this.$router.push('payment-pending');
        } else {
          this.$store.commit('ancillaryFromItinerary', false);
          this.$router.replace('itinerary');
        }
      },
      onContinue: function () {
        if (this.ancillaryFromItinerary) {
          this.goAfterAncillary();
          return;
        }
        this.$router.push('seats');
      }
    },
    mounted() {
      if (_.isEmpty(this.booking)) {
        this.$router.replace('/');
        return;
      }
      if (this.ancillaryFromItinerary && bookingHasCharterFlight(this.booking)) {
        this.$store.commit('ancillaryFromItinerary', false);
        this.$router.replace('itinerary');
      }
    }
  }
</script>

<style scoped>
.ancillary-summary-card {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  padding: 18px 16px 14px;
}
.ancillary-summary-card h4 {
  margin: 0 0 16px;
  color: #333;
  font-size: 18px;
  font-weight: 700;
}
.ancillary-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  color: #555;
  font-size: 14px;
}
.ancillary-summary-row strong {
  color: #222;
  font-size: 15px;
  white-space: nowrap;
}
.ancillary-summary-due {
  color: #cc353a !important;
}
.ancillary-summary-back {
  color: #666;
  margin-top: 4px;
}
</style>
